import React from 'react';
import PropTypes from 'prop-types';

const Heart = ({ className, active = false, onClick = () => {}, strokeColor = '#f7988b', fillColor = '#ffffff' }) => (
  <svg
    width={18}
    height={18}
    x={0}
    y={0}
    viewBox="0 0 18 18"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className} ${active ? 'active' : ''}`}
    onClick={onClick}
  >
    <path
      d="M9 3.348C4.68-3.78-6.607 6.804 9 15.318 24.608 6.804 13.32-3.78 9 3.348z"
      fill={fillColor}
      stroke={strokeColor}
      strokeWidth="1.4"
      fillRule="evenodd"
    />
  </svg>
);

Heart.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  strokeColor: PropTypes.string,
  fillColor: PropTypes.string
};

export default Heart;
